var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#069;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.292A2.33,2.33,0,0,1,2.365,0h27.27A2.33,2.33,0,0,1,32,2.292V29.708A2.329,2.329,0,0,1,29.635,32H2.365A2.33,2.33,0,0,1,0,29.708V2.292Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.314,64.841V50.393h-4.8V64.841h4.8Zm-2.4-16.421a2.5,2.5,0,1,0-2.684-2.5,2.485,2.485,0,0,0,2.653,2.5h.031Zm5.056,16.421h4.8V56.774a3.289,3.289,0,0,1,.158-1.172,2.627,2.627,0,0,1,2.463-1.757c1.737,0,2.432,1.325,2.432,3.267v7.729h4.8V56.557c0-4.438-2.368-6.5-5.526-6.5a4.783,4.783,0,0,0-4.358,2.434h.032V50.393h-4.8c.063,1.355,0,14.448,0,14.448Z",
    transform: "translate(-32.603 -38.031)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon2);
export default __webpack_public_path__ + "static/media/linkedin-icon-2.30978b76b0a3e5aa54cff7b8e08d0df4.svg";
export { ForwardRef as ReactComponent };